{
  "languageFlag": "🇬🇧",
  "languageFull": "🇬🇧 English",
  "languages": {
    "fr": "French (Français)",
    "en": "English"
  },
  "impersonationWarning": "You are currently impersonating a user",
  "activity": {
    "title": "Physical activity",
    "intensity": "Intensity",
    "duration": "Duration",
    "durationUnit": "min"
  },
  "admin": {
    "title": "Admin",
    "logout": "Logout"
  },
  "alertConfig": {
    "bgm": "BGM",
    "cgm": "CGM",
    "atLeast": "At least",
    "inThe": "in the last",
    "lastDays": "days",
    "moreThan": "more than",
    "timeSpentInHyper": "of time spent in hyperglycemia",
    "timeSpentInHypo": "of time spent in hypoglycemia",
    "highOrVeryHigh": "high or very high",
    "lowOrVeryLow": "low or very low",
    "veryHigh": "very high",
    "veryLow": "very low",
    "monoInjection": "mono-injection",
    "multiInjection": "multi-injections",
    "measuresPerDay": "measures min per day",
    "measuresPerDayNoMinumum": "measures per day",
    "scansPerDay": "scans min per day",
    "capillaryMeasures": "Capillary blood glucose",
    "interstitialMeasures": "Interstitial blood glucose (CGM)",
    "title": "Alerts",
    "type": "Alert type",
    "priority": "Priority",
    "conditions": "Conditions",
    "prioritySuccess": "Priority updated",
    "priorityError": "Error while updating priority",
    "conditionsSuccess": "Conditions for alert {{alert}} have been updated",
    "conditionsError": "Error while updating conditions for alert {{alert}}",
    "deleteSuccess": "Alert {{alert}} has been deleted",
    "deleteError": "Error while deleting alert {{alert}}",
    "create": "Create an alert",
    "createTitle": "Alert creation",
    "unspecified": "Unspecified",
    "technicalAlert": "Technical issues",
    "hyperglycemiaEvent": "Hyperglycemia event",
    "hyperglycemiaEventTar": "Time above range (TAR)",
    "timeInRange": "Time in range (TIR)",
    "timeInRangeSpent": "Time spent in range",
    "hypoglycemiaEvent": "Hypoglycemia event",
    "hypoglycemiaEventTbr": "Time below range (TBR)",
    "perceivedHyperglycemia": "Perceived hyperglycemia",
    "perceivedHypoglycemia": "Perceived hypoglycemia",
    "perceivedSevereHypoglycemia": "Perceived severe hypoglycemia",
    "severeHypoglycemia": "Severe hypoglycemia",
    "notificationTriggeredAsSoonAsEventIsNoted": "Alert triggered as soon as event is noted",
    "transmission": "Observance transmission",
    "measurement": "Observance measurements",
    "withdrawalOfConsent": "Withdrawal of consent",
    "intervention": {
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "noTransmission": "No glycemia transmitted",
    "other": "Other",
    "noAlertBGM": "No BGM alert configured, you can add one by clicking the button below",
    "noAlertCGM": "No CGM alert configured, you can add one by clicking the button below",
    "noAlertOther": "No other alert type configured, you can add one by clicking the button below",
    "periods": {
      "all": "All periods",
      "fasting": "Fasting",
      "beforeMeal": "Before meal",
      "afterMeal": "After meal"
    }
  },
  "atoms": {
    "richText": {
      "h5": "Heading",
      "normal": "Normal"
    }
  },
  "bgmLogBook": {
    "activityTooltip": "Physical activity: time, intensity",
    "average": "Avg. 7d",
    "cardTitle": "Daily blood sugar log",
    "eventTooltip": "Event: time, type, comments",
    "fastInsulin": "Fast Insulin",
    "fastInsulinHeader": "FI",
    "glycemiaAfter": "Post meal Glucose",
    "glycemiaAfterHeader": "BS.Af.",
    "glycemiaBefore": "Blood Sugar Before",
    "glycemiaBeforeHeader": "BS.Be.",
    "low": "Light",
    "mealTooltip": "Meal : consistency or carbs quantity, comments",
    "nightTime": "Night time",
    "slowInsulin": "Slow Insulin",
    "slowInsulinHeader": "SI",
    "unknown": "Not specified",
    "comment": "Comment",
    "glycemia": "Glycemia",
    "date": "Date",
    "loadOneMoreWeek": "Load one more week",
    "loadMore": "Load more",
    "downIsPast": "Display descending date",
    "downIsFuture": "Display ascending date"
  },
  "button": {
    "cancel": "Cancel",
    "validate": "Validate",
    "back": "Back",
    "next": "Next",
    "pending": "Loading",
    "submit": "Submit",
    "reject": "Reject",
    "accept": "Accept",
    "edit": "Edit",
    "tryAgain": "Try again",
    "save": "Save",
    "upload": "Upload",
    "generate": "Generate"
  },
  "carePlanInterruption": {
    "action": "End telemonitoring",
    "modalTitle": "End telemonitoring",
    "modalSubtitle": "Reason for ending the telemonitoring:",
    "reasons": {
      "consentWithdrawal": "Withdrawal of consent",
      "deceased": "Death",
      "other": "Other"
    },
    "successToast": "Telemonitoring has been interrupted."
  },
  "carePlans": {
    "history": "History",
    "historyTitle": "Prescription history",
    "historyPrescriptionTitle": "Prescription",
    "historyPeriodTitle": "Period",
    "historyTelemonitoringTierTitle": "Level",
    "historyTelemonitoringCriteriaTitle": "Inclusion criteria",
    "historyObjectivesTitle": "Objectives",
    "historyObjectivesText": "Text",
    "historyObjectivesFile": "File",
    "noCarePlans": "No prescription found",
    "copyDescription": "Copy objectives"
  },
  "charts": {
    "afterMeal": "After meal",
    "basal": "Slow ins.",
    "beforeMeal": "Before meal",
    "bolus": "Fast ins.",
    "carbs": "Carbs",
    "correction": "Correction",
    "events": "Events",
    "extended": "Extended",
    "glucose": "Glucose",
    "glycemiaSpread": "Spread of glycemia",
    "instant": "Instant",
    "manual": "Manual",
    "meal": "Meal",
    "data": "Data",
    "noData": "No data to display",
    "timeBetweenThresholds": "Time between thresholds",
    "inputMethod": {
      "manual": "Manual",
      "sensor": "Interstitial",
      "reader": "Capillary",
      "pump": "Pump",
      "pen": "Pen"
    },
    "glycemia": {
      "glycemia": "Glycemia",
      "glycemia_short": "Glyc.",
      "glycemiaUnit": "mg/dL"
    },
    "insulin": {
      "bolus": "Bolus",
      "bolusUnit": "U",
      "carbs": "Carbs",
      "carbs_short": "Carbs",
      "carbsUnit": "g",
      "basalRate": "Basal rate",
      "basalRate_short": "Basal",
      "basalRateUnit": "U/h",
      "fast": "Fast Ins",
      "fast_short": "FI",
      "fastUnit": "U",
      "slow": "Slow Ins",
      "slow_short": "SI",
      "slowUnit": "U",
      "closedLoop": "Mode"
    }
  },
  "clipboard": {
    "unsupported": "Clipboard copy is not available",
    "copied": "Content copied to clipboard",
    "failed": "Failed to copy content to clipboard"
  },
  "fileReports": {
    "noData": "No available report for these dates"
  },
  "condition": {
    "unspecified": "Unspecified",
    "term": "Term"
  },
  "contact": {
    "entourage": "Entourage",
    "addRelationship": "Add a relationship",
    "editRelationship": "Edit a relationship",
    "notEntered": "Not entered",
    "emergencyContact": "Emergency contact ?",
    "relationshipWithPatient": "Relationship with the patient",
    "noName": "Nom non renseigné"
  },
  "devices": {
    "sensor": "Interstitial Sensor",
    "reader": "Reader",
    "pump": "Insulin Pump",
    "manual": "Manual",
    "pen": "Insulin Pen",
    "libreLink": "Via LibreView"
  },
  "diabetesForms": {
    "createPatient": "Add a patient",
    "telemonitoring": "Telemonitoring",
    "diabetesType": "Diabetes type",
    "insulinScheme": "Insulin delivery method",
    "insulin": {
      "insulinPen": "Insulin pen",
      "insulinPump": "Insulin pump",
      "noInsulin": "No insulin",
      "insulinPumpsComingSoon": "Insulin pumps will be available soon on Stēto"
    },
    "tier": "Reimbursement level",
    "criteria": "Telemonitoring criteria",
    "criteriaBase": "Base",
    "criteriaBaseHeader": "Base",
    "criteriaBaseInfo": "Monitoring of a patient with type 1 diabetes, initiation of basal insulin in a type 2 diabetic, monitoring of type 2 diabetes under multi-injections",
    "criteriaLevel1": "Level 1",
    "criteriaLevel1Header": "Level 1",
    "criteriaLevel1Info": "Discovery of type 1 diabetes in an adult patient, \nmonitoring of type 1 diabetes in an adolescent patient, \ntransient imbalances (corticosteroid therapy), \nmonitoring of gestational diabetes",
    "criteriaLevel2": "Level 2",
    "criteriaLevel2Header": "Level 2",
    "criteriaLevel2Info": "Discovery of type 1 diabetes in an adolescent patient, \nmonitoring of adolescents in care gaps, \npregnancy of a diabetic woman",
    "criteriaMeaningBase": "This inclusion criterion corresponds to a base-level doctor reimbursement",
    "criteriaMeaningLevel1": "This inclusion criterion corresponds to a level 1 doctor reimbursement",
    "criteriaMeaningLevel2": "This inclusion criterion corresponds to a level 2 doctor reimbursement",
    "goals": "Therapeutic goals and care process",
    "goalsShort": "Therapeutic goals",
    "nurseInformation": "Information for the nurse",
    "treatmentPrescription": "Treatment prescription",
    "referralLetter": "Referral letter",
    "goalsNone": "No therapeutic goals",
    "termDate": "Term date",
    "nonTelemonitoredPatient": "Non-telemonitored patient",
    "noInsulinMonitoringHelpText": "Gestational diabetes without insulin is not eligible for reimbursed telemonitoring. The patient will therefore not be assisted by your nurse, but it will still be possible to offer her nursing support if she begins insulin therapy.",
    "addInsulin": "Add insulin",
    "prescription": "Telemonitoring prescription",
    "prescriptionDescription": "or add a prescription for three months starting on",
    "prescriptionGeneration": "Prescription generation",
    "prescriptionDownload": "Download the prescription",
    "prescriptionSignSuccess": "The prescription has been signed",
    "prescriptionNone": "No prescription",
    "addPrescription": "Add a prescription",
    "generatePrescription": "Generate a prescription",
    "existingPatient": {
      "title": "Patient already on Stēto",
      "monitoredByMe": "A patient with this email address or phone number already exists in your Stēto patient list. You can re-include them directly from their patient profile. If this is a different patient sharing the same contact details (e.g. a spouse), please get in touch with your Stēto contact.",
      "monitoredByOther": "This patient is already monitored by another doctor on Stēto. Contact Stēto to carry on with the inclusion.",
      "goToPatient": "View patient"
    },
    "prescriptionDuration": "Duration of the telemonitoring",
    "pumpModel": "Pump brand",
    "prescriptionAddition": "Addition of the prescription",
    "prescriptionSignature": "Signature",
    "addDescription": "Add therapeutic goals",
    "weight": "Weight (kg)",
    "weightUnit": "kg",
    "months": "months",
    "prescriptionLabel": "Add a file",
    "prescriptionTooltip": "The prescription must include the following elements:\n\n- patient's name\n- age\n- weight\n- designation “diabetes telemonitoring”\n- duration: 3 months\n- platform: Stēto",
    "periodStart": "Start date",
    "duration": "Telemonitoring duration (in months)",
    "dates": "Ongoing telemonitoring",
    "renew": "Renew the telemonitoring",
    "restartMonitoring": "Restart monitoring",
    "renewed": "Renewed",
    "hasUntilTerm": "Renewed until term",
    "cannotRenewDeceased": "Patient deceased",
    "cannotRenewDeceasedTooltip": "The patient has been marked as deceased, so their telemonitoring cannot be renewed. Please contact Stēto support if this is an error.",
    "restriction": "This patient has already been monitored for 6 consecutive months at level 1 or 2. Therefore, only the basic level of monitoring is available.",
    "responsibleDoctor": "Doctor",
    "responsibleNurse": "Nurse",
    "inclusionCriteriaLabel": {
      "adultMonitoringD1": "Monitoring of T1D in an adult",
      "adultDiscoveryD1": "Discovery of T1D in an adult",
      "teenMonitoringD1": "Monitoring of T1D in a teenager",
      "teenDiscoveryD1": "Discovery of T1D in a teenager",
      "corticotherapie": "Situation of transient imbalances",
      "teenCareGap": "Monitoring of teenagers with care gaps",
      "pregnateD": "Grossesse d'une femme diabétique",
      "gestational": "Pregnancy in a diabetic woman",
      "startBasalD2": "Initiation of basal insulin in a T2D",
      "monitoringD2": "Monitoring of T2D on insulin",
      "gestationalInsulined": "Gestational diabetes on insulin",
      "pumpMonitoring": "Monitoring of a treatment by insulin pump",
      "pumpInitiation": "Initiation of a treatment by insulin pump",
      "pumpHybridInitiation": "Initiation of a hybrid pump treatment",
      "basePrice": "Base Rate",
      "level1Price": "Level 1 Rate",
      "level2Price": "Level 2 Rate",
      "noRefund": "Not Reimbursed"
    },
    "supportedPumpsTitle": "Available pumps on Stēto",
    "hsp": "HealthCare Provider",
    "addProvider": "New Provider",
    "otherHSP": "New provider - Stēto will contact you",
    "eitherObjectiveOrFile": "Therapeutic goals must be filled in and/or a file must be added",
    "minimumWeight": "Weight must be greater than 0 kg",
    "maximumWeight": "Weight must be less than 1000 kg",
    "signAndAddPatient": "Sign and add patient",
    "signAndRenewPatient": "Sign and renew patient",
    "addPatient": "Add patient",
    "addNurseInclusion": "Pré-inclure un patient",
    "renewPatient": "Renew patient",
    "medtronicSupportedPumps": "<0>Medtronic: </0><1>MiniMed 640G, 740G and 780G (new)</1>",
    "insuletSupportedPumps": "<0>Insulet: Omnipod Dash and </0><1>Omnipod 5 (new)</1>",
    "tandemSupportedPumps": "<0>Tandem: t:slim X2 and t:slim X2 Control IQ</0>",
    "supportedPumpsInfo": "New pumps will be added regularly in the coming months",
    "patientCreated": "Patient has been successfully created",
    "clickToView": "Click to view the patient",
    "noFile": "No file",
    "attachments": "Attachments",
    "writeGoals": "Write therapeutic goals",
    "editGoals": "Edit goals",
    "goalsUpdated": "Therapeutic goals updated",
    "goalsAttachmentUpdated": "Therapeutic goals attachment updated",
    "goalsAttachmentDeleted": "Therapeutic goals attachment deleted",
    "treatmentPrescriptionUpdated": "Treatment prescription updated",
    "treatmentPrescriptionDeleted": "Treatment prescription deleted",
    "uploadTreatmentPrescription": "Attach a treatment prescription",
    "referralLetterUpdated": "Referral letter updated",
    "referralLetterDeleted": "Referral letter deleted",
    "uploadReferralLetter": "Attach a referral letter",
    "uploadGoals": "Attach therapeutic goals",
    "diabetesAndSchema": "Diabetes and devices"
  },
  "errors": {
    "title": "Error",
    "waitAFewMinutes": "Please wait a few minutes",
    "or": "or",
    "unknownError": "A technical error occurred",
    "invalidPhoneNumber": "Invalid phone number",
    "userAlreadyExists": "This patient already has an account, please contact {{supportEmail}}",
    "accountAlreadyExists": "This patient already has an account, please contact support.",
    "carePlansOverlapping": "The telemonitoring dates overlap with the current telemonitoring",
    "carePlanAlreadyRenewed": "The telemonitoring has already been renewed",
    "fileSizeError": "The file size must not exceed {{max_size}}: {{size}} / {{max_size}}",
    "dateFormat": "The date format is incorrect",
    "unauthorizedPatientAccess": "The patient does not exist or you do not have permission to view this patient",
    "pageNotFound": "Page does not exist",
    "emailOrPhoneAlreadyInUse": "This email or phone is already in use by one of your patients",
    "unknownErrorFull": "A technical error has occurred. Please contact support."
  },
  "food": {
    "title": "Meal",
    "carbs": "Carbs",
    "carbsUnit": "g",
    "meal": "Meal",
    "size": "Size",
    "comments": "Commentaire"
  },
  "form": {
    "required": "The field is required",
    "atLeastOne": "At least one field must be filled",
    "pastDate": "The date cannot be in the past",
    "email": {
      "label": "Email address",
      "required": "An email address is required",
      "invalid": "Invalid email address"
    },
    "text": {
      "required": "The field is required",
      "firstnameRequired": "The first name is required",
      "lastnameRequired": "The last name is required",
      "comment": "Comment"
    },
    "number": {
      "invalid": "The field must be a number",
      "integer": "The field must be an integer",
      "positive": "The field must be positive",
      "min": "The field is less than the minimum value",
      "max": "The field is greater than the maximum value"
    },
    "phone": {
      "label": "Phone number",
      "required": "A phone number is required",
      "invalid": "Invalid phone number"
    },
    "helperPhone": {
      "label": "Helper for connection (optional)",
      "placeholder": "Phone number"
    },
    "file": {
      "label": "File",
      "required": "Only files of the following type are supported : {{extensions}}",
      "tooBig": "The file must not be bigger than 10 MB"
    },
    "date": {
      "format": "DD/MM/YYYY",
      "invalid": "Invalid date (DD/MM/YYYY)",
      "future": "Date must be in the past",
      "past": "Date must be in the future"
    }
  },
  "glycemia": {
    "title": "Glucose",
    "hyperglycemia_one": "Hyperglycemia",
    "hyperglycemia_other": "Hyperglycemias",
    "hypoglycemia_one": "Hypoglycemia",
    "hypoglycemia_other": "Hypoglycemias"
  },
  "identityValidation": {
    "title": "Validate patients identities",
    "subtitle": "The identities of the patients below must be validated before you can continue"
  },
  "nurseInclusion": {
    "doctorSelect": "Telemonitoring doctor",
    "nurseSelect": "Telemonitoring nurse",
    "patientInfo": "Patient information",
    "banner": "The patient will receive a login email once the doctor has validated the inclusion",
    "inclusionReason": "Reason for inclusion suggestion",
    "inclusionSent": "Suggestion sent successfully",
    "inclusionProposal": "Inclusion suggestion",
    "inclusionProposalBy": "Inclusion suggested by {{nurse}}",
    "examineSuggestion": "Examine the request",
    "reject": "Reject",
    "accept": "Validate the suggestion",
    "addPatient": "Inclusion suggested by {{nurse}}",
    "history": {
      "title": "Inclusion suggestion history",
      "createdAt": "Suggestion date",
      "doctor": "Doctor",
      "name": "Patient name",
      "birthDate": "Birth date",
      "email": "Email address",
      "status": "Inclusion status",
      "cancelDemand": "Cancel demand",
      "cancelDemandTitle": "Cancel inclusion demand",
      "cancelDemandDescription": "Are you sure you want to cancel this inclusion demand? This action is irreversible.",
      "noInclusion": "No inclusion"
    }
  },
  "pumpMode": {
    "title": "Pump system",
    "auto": "Auto",
    "manual": "Manual"
  },
  "insulin": {
    "title": "Insulin",
    "fastInsulinPerDay": "Fast insulin / day",
    "slowInsulinPerDay": "Slow insulin / day",
    "bolusInsulinPerDay": "Bolus insulin / day",
    "basalInsulinPerDay": "Basal insulin / day",
    "averageInsulinPerDay": "Avg. insulin / day",
    "averageNbInjectionsPerDay": "Avg. nb. injections / day",
    "averageNbBolusInjectionsPerDay": "Avg. nb. bolus / day",
    "averageNbBolusPerDay": "Avg. nb. bolus / day",
    "suggested": "Suggested",
    "quantity": "Delivered",
    "type": "Type",
    "reason": "Reason",
    "suggestedFoodInsulin": "Suggested meal",
    "foodInsulin": "Meal",
    "carbs": "Carbs",
    "carbsRatio": "Ratio",
    "suggestedCorrection": "Suggested Cor.",
    "correction": "Correction",
    "glycemia": "Glycemia",
    "insulinSensitivity": "Sensitivity",
    "targetGlycemia": "Target glycemia",
    "iob": "Active insulin"
  },
  "insulinPump": {
    "total": "Total",
    "timeRange": "",
    "basalRate": "Basal rate",
    "carbsRatio": "Ratio",
    "insulinSensitivity": "Sensitivity",
    "activeInsulinTime": "Active insulin time",
    "targetBloodGlucose": "Target glycemia",
    "profiles": "Pump parameters",
    "model": "Model",
    "lastUpload": "Last upload",
    "profile": "Profile",
    "units": {
      "basalRate": "U/h",
      "carbsRatio": "g/U",
      "insulinSensitivity": "mg/dL/U",
      "activeInsulinTime": "min",
      "targetBloodGlucose": "mg/dL"
    }
  },
  "messaging": {
    "me": "Me",
    "everybody": "Everybody",
    "all": "Every messages",
    "medicalStaff": "Medical staff",
    "recipient": "Recipient",
    "toAllPlaceholder": "Message visible to the patient and the medical team",
    "toPractitionerPlaceholder": "Message visible to the medical team only",
    "noNurse": "Patient has no nurse",
    "patientOnly": "Message for your patient only",
    "deleted": "Message deleted",
    "unread": "Unread",
    "noMessages": "No messages for now",
    "readBy": "Read by",
    "reactions": {
      "react": "React with {{emoji}}",
      "badge": "{{emoji}} reaction, {{count}} total",
      "openPicker": "Add a reaction",
      "pickerLabel": "Choose a reaction"
    }
  },
  "patientEvents": {
    "carePlanDeleted": "Unable to connect the patient, their monitoring has been terminated.",
    "header": "Évènement",
    "decidedNotToRenew": {
      "beforeEndCP": {
        "self": "You have ended the patient's telemonitoring, at the end of the current prescription",
        "other": "{{doctorName}} has decided not to renew the telemonitoring at the end of the current prescription."
      },
      "afterEndCP": {
        "self": "You have ended the patient's telemonitoring",
        "other": "{{doctorName}} has decided not to renew the telemonitoring."
      }
    },
    "carePlanRenewed": {
      "self": "You have renewed the patient's telemonitoring",
      "other": "{{doctorName}} has renewed the telemonitoring."
    },
    "careplanInterrupted": {
      "self": "You have interrupted the patient's telemonitoring",
      "other": "{{doctorName}} has interrupted the patient's telemonitoring",
      "steto": "Stēto has ended the patient's telemonitoring at the medical team's request"
    },
    "aircall": {
      "callNotAnswered": "Call attempt to the patient by the Stēto team",
      "callAnswered": "Call between the Stēto team and the patient - Duration: {{duration}} minutes",
      "smsSentBySteto": "SMS sent to the patient by the Stēto team",
      "smsSentByPatient": "SMS sent by the patient to the Stēto team"
    },
    "nurseReinclusion": {
      "selfRequested": "You have proposed the reactivation of this patient",
      "otherRequested": "{{doctorName}} has proposed the reactivation of this patient",
      "selfCancelled": "You have cancelled the reactivation of this patient",
      "otherCancelled": "{{doctorName}} has cancelled the reactivation of this patient",
      "selfRefused": "You have refused the reactivation of this patient",
      "otherRefused": "{{doctorName}} has refused the reactivation of this patient"
    },
    "rpmStarted": "Patient connected, monitoring can start",
    "deceased": "Following the patient's passing, telemonitoring has been ended"
  },
  "navbar": {
    "myPatients": "My patients",
    "disconnect": "Disconnect",
    "practitionerBilling": "Billing",
    "patientSync": "Synchronization"
  },
  "notifications": {
    "title": "Active notifications",
    "none": "No active notifications"
  },
  "pages": {
    "notFound": {
      "title": "Page not found"
    },
    "addMeasurement": {
      "choose": "Choose"
    },
    "account": {
      "title": "My account",
      "about": {
        "title": "About Stēto",
        "description": "Stēto is a regulated health product that carries, under this regulation, a CE marking of class I. See instructions for use. The Stēto application is a diabetes telemonitoring solution made and developed by :",
        "name": "Stēto",
        "address": "12 Boulevard de Port Royal",
        "postCode": "75005 Paris",
        "rcs": "918012121 RCS de Paris",
        "class": "Class I medical device"
      },
      "absenceMessage": {
        "title": "Absence message",
        "helpText": "Send a message to all your patients currently under telemonitoring to inform them of your absence.",
        "template": "Hello,\nI am writing to inform you that I will be on leave from XX/XX/XXX to XX/XX/XXX.\nKind regards,\n{{name}}",
        "send": "Send",
        "confirmTitle": "Confirm sending",
        "confirmIntro": "I confirm sending the following message to all my patients under active telemonitoring:",
        "confirm": "Confirm",
        "successTitle": "Message sent",
        "successSubtitle": "Your message has been sent to your patients.",
        "errorMessage": "An error occurred while sending the message. Please try again."
      },
      "generalInformation": {
        "title": "General information"
      },
      "preferences": {
        "title": "Email notification preferences",
        "nursePing": "Patient reported",
        "nurseToDoctor": "New message from a nurse",
        "patientToNurse": "New message from a patient",
        "doctorToNurse": "New message from a doctor",
        "dgNoInsulinPatientToDoctor": "New message from a DG patient that has no nurse",
        "patientExpiresSoon": "Patient telemonitoring expires soon",
        "patientExpiresSoonNurse": "Patient telemonitoring expires soon"
      },
      "language": {
        "title": "Language"
      },
      "security": {
        "title": "Sécurity",
        "updatePassword": "Change my password"
      },
      "terms": {
        "title": "Terms of use"
      },
      "userHelp": {
        "title": "Need help ?",
        "description": "Need help  ?",
        "contactUs": "Contact us at {{supportEmail}}",
        "or": "or",
        "userManual": "consult our user manual"
      }
    },
    "search": {
      "title": "Recherche d'antériorité",
      "CTA": "Chercher",
      "CTARedirectButton": "Rechercher un patient",
      "form": {
        "dob": "Date of birth",
        "NIR": "Numéro NIR",
        "names": "Nom / Prénom(s)"
      },
      "table": {
        "birthName": "Nom de naissance",
        "usedLastName": "Nom utilisé",
        "firstRegulatoryFirstName": "Premier prénom de naissance",
        "usedFirstName": "Prénom utilisé",
        "dob": "Date de naissance",
        "gender": "Sexe",
        "status": "Statut de l’identité",
        "nir": "Numéro NIR",
        "CTA": "Voir",
        "noData": "Aucun résultat"
      }
    },
    "patientMonitoring": {
      "title": "Patient monitoring",
      "noData": "No data to display",
      "loadMoreRecent": "Load more recent data",
      "syncingData": "Syncing the patient's data for today, this should take less than 30 seconds",
      "agp": {
        "title": "AGP profile",
        "glycemiaMgDl": "Glycemia (mg/dL)",
        "longTermEvolution": "See long-term evolution"
      },
      "glycemia": {
        "title": "Daily glycemia profiles",
        "estimatedHba1c": "Estimated HbA1c",
        "averageReader": "Avg. gluc. reader",
        "averageSensor": "Avg. gluc. sensor",
        "averageMeasuresPerDay": "Avg. measures/day",
        "nbHypo": "Nb. hypo",
        "coefVariation": "Coef. variation",
        "sensorUsage": "Sensor usage"
      },
      "insulin": {
        "slow": "Slow insulin",
        "fast": "Fast insulin",
        "averageInsulinPerDay": "Avg. insulin/day",
        "averageNbInjectionsPerDay": "Avg. nb. injections/day",
        "averageNbBolusPerDay": "Avg. nb. bolus/day"
      },
      "patient": {
        "title": "Patient information",
        "helperSection": "Helper to contact for connection (optional)",
        "age": "{{age}} years",
        "diabetes": {
          "type1": "Diabète type 1",
          "type2": "Diabète type 2",
          "gestational": "Diabète gestationnel"
        },
        "insulin": {
          "noInsulin": "No insulin",
          "insulinPen": "Insulin pen",
          "insulinPump": "Insulin pump"
        },
        "insulinScheme": "Insulin delivery method",
        "unspecifiedInsulinScheme": "Insulin scheme not specified",
        "unspecifiedDiabetesType": "Diabetes type not specified"
      },
      "dailyDataError": "Error while loading daily data"
    },
    "patientMedicalFile": {
      "diabetesAndDevices": "Diabetes and medical devices",
      "lastSync": "Latest data",
      "neverSynced": "never",
      "thereIs": "{{duration}} ago",
      "notes": "Medical team notes",
      "emptyNote": "\"<i>You do not have any notes for this patient yet</i>\"",
      "editNote": "Edit note",
      "writeNote": "Write a note",
      "noteSuccess": "Note saved successfully"
    },
    "addMeasurementFile": {
      "dexcom": {
        "title": "Dexcom",
        "integrationSuccess": "Dexcom integration successful",
        "integrationSuccessHelpText": "Your Dexcom account has been successfully integrated. You can now view your data in the Stēto application.",
        "integrationError": "An error occurred during Dexcom integration",
        "integrationErrorHelpText": "An error occurred while connecting to your Dexcom account. We recommend trying again in a few minutes. If it still doesn't work, you can contact support at {{supportPhone}} or email us at {{supportEmail}}",
        "alreadyIntegrated": "Dexcom is already integrated",
        "alreadyIntegratedHelpText": "You have already integrated your Dexcom account. If you wish to reset it, you can contact support at {{supportPhone}} or email us at {{supportEmail",
        "integrationDenied": "Dexcom integration was denied",
        "integrationDeniedHelpText": "You have denied access to your Dexcom account. You need to accept the connection to view your data in the Stēto application.",
        "dexcomData": "Dexcom CGM",
        "clarityNotEnabled": "Clarity sharing is not enabled",
        "clarityNotEnabledHelpText": "You must first enable the sharing of your data with third-party applications in the Dexcom Clarity application. To do this, go to the Dexcom Clarity application, then to the settings, and finally to the sharing section."
      },
      "chooseFile": "Choose a file",
      "chooseMedicalDeviceToLoad": "Choose my medical device to download",
      "error": "An error occurred while saving your file",
      "fsl": {
        "addData": "Download data from my FreeStyle Libre",
        "instructions": "You must first go to the LibreView website to retrieve your CSV data file. Then select the file:"
      },
      "fslWithAbbottSmartphone": "FreeStyle Libre sensor scanned with my ABBOTT smartphone",
      "noFileChosen": "No file chosen",
      "success": "Your file has been saved"
    },
    "patientSettings": {
      "telemonitoring": {
        "title": "Telemonitoring",
        "activate": "Activate telemonitoring",
        "edit": "Edit telemonitoring"
      }
    },
    "login": {
      "connection": "Connection",
      "disclaimer": "Welcome to Stēto!\nWe are delighted to see you here.\nIf you are a patient or a member of the patient's entourage, you must first have created your account from the mobile application before continuing.",
      "practitionerTitle": "You are a practitioner",
      "practitionerPill": "Access your practitioner space on the Stēto web application",
      "practitionerNoAccount": "Don't have a Stēto account yet?\nWrite to us at contact@steto.care, we will get back to you as soon as possible",
      "patientTitle": "You are a patient",
      "patientPill": "Download the mobile application on your smartphone to start your follow-up",
      "patientInstructions": "From your phone, log in to the app.steto.care website and click on one of the two buttons above",
      "patientDetails": "You are logged in with a patient account. You must download the mobile application from your phone to access your monitoring. To do this, log in to app.steto.care from your phone and click on one of the two buttons below: ",
      "iphone": "iPhone",
      "otherSmartphone": "Other smartphone"
    },
    "patients": {
      "title": "My patients",
      "addPatient": "Add a patient",
      "addNurseInclusion": "Pré-inclure un patient",
      "editPatient": "Edit",
      "patientInfo": "Information about the patient",
      "notifications": "Patient reported",
      "toConsult": "Patient reported",
      "messages": "Messages",
      "diabetesType": "Diabetes",
      "telemonitoring": "Telemonitoring",
      "monitored": "Active T1/2D",
      "pregnant": "Active pregnancies",
      "all": "All",
      "referentDoctor": "Doctor",
      "tlsNurse": "Nurse",
      "renewal": "Renewal",
      "lastSeen": {
        "header": "Seen",
        "olderThanMonth": "More than 1 month ago",
        "olderThanTwoWeeks": "More than 2 weeks ago",
        "recent": "Less than 2 weeks",
        "unknown": "Never",
        "never": "Never"
      },
      "columns": {
        "patientName": "Patient"
      },
      "columnVisibility": {
        "title": "Displayed columns",
        "toggle": "Columns",
        "restoreDefaults": "Restore defaults"
      }
    },
    "renewPopup": {
      "title": "Renwal of your patient",
      "body": "The remote monitoring of your patient has expired, and they are no longer being assisted by your nurse. Would you like to continue their support?",
      "yes": "Yes",
      "no": "No",
      "decideLater": "Decide later"
    },
    "practitionerBilling": {
      "title": "Billing",
      "fileName": "File name",
      "period": "Period",
      "lastUpdate": "Last update",
      "status": "Status",
      "noData": "No available file"
    }
  },
  "patientInfo": {
    "noPhoneNumber": "Phone number not provided",
    "placeOfBirth": "Born in",
    "placeOfBirth_female": "Born in",
    "placeOfBirth_male": "Born in",
    "countryOfBirth": "Born in",
    "countryOfBirth_female": "Born in",
    "countryOfBirth_male": "Born in"
  },
  "patientNavigation": {
    "lastSeen": "Last seen",
    "medicalFile": "Medical file",
    "noFirstConnection": "No first connection",
    "monitoring": "Diabetes monitoring",
    "settings": "Settings",
    "dailyView": "Daily view",
    "notice": {
      "notifyDoctor": "Report to the doctor",
      "cancelNotify": "Cancel the report",
      "mitigateNotify": "Validate the report",
      "notified": "Patient reported",
      "banner": "Your nurse has reported this patient"
    },
    "renewalNudge": {
      "expires_today": "<0>L’ordonnance de {{patientName}} expire aujourd’hui.</0> Prévenez votre infirmier si il doit continuer d’accompagner votre patient à l’issue de la prescription en cours.",
      "expires_tomorrow": "<0>L’ordonnance de {{patientName}} expire demain.</0> Prévenez votre infirmier si il doit continuer d’accompagner votre patient à l’issue de la prescription en cours.",
      "expires_soon": "<0>L’ordonnance de {{patientName}} expire dans {{days}} jours.</0> Prévenez votre infirmier si il doit continuer d’accompagner votre patient à l’issue de la prescription en cours.",
      "expired": "<0>L’ordonnance de {{patientName}} a expiré il y a {{days}} jours.</0> Prévenez votre infirmier si il doit arrêter d’accompagner votre patiente.",
      "expired_yesterday": "<0>L’ordonnance de {{patientName}} a expiré hier.</0> Prévenez votre infirmier si il doit arrêter d’accompagner votre patiente.",
      "ctas": {
        "continue": "Poursuivre le suivi",
        "stop_later": "Arrêter le suivi dans {{days}} jours",
        "stop_tomorrow": "Arrêter le suivi demain",
        "stop_today": "Arrêter le suivi aujourd'hui",
        "stop_now": "Mettre un terme au suivi"
      }
    },
    "dataManagement": "Data management"
  },
  "periodicity": {
    "customize": "{{count}} days",
    "yesterday": "Yesterday",
    "oneWeek": "7 days",
    "twoWeeks": "14 days",
    "oneMonth": "30 days",
    "threeMonths": "90 days",
    "sixMonths": "180 days"
  },
  "prescription": {
    "sign": "Signe",
    "renew": "Renew"
  },
  "profile": {
    "address": "Address",
    "birth": "Birth information",
    "birthCity": "Birth city",
    "birthCountry": "Birth country",
    "birthDate": "Birth date",
    "birthDate_short": "Birth",
    "birthPlace": "Birth place",
    "birthPostCode": "Birth post code",
    "diabetologist": "Diabetologist",
    "doctor": "Doctor",
    "email": "Email",
    "female": "Female",
    "firstname": "Used firstname",
    "gender": "Gender",
    "identityFirstname": "First birth firstname",
    "identityFirstnames": "Birth firstname",
    "identityLastname": "Birth lastname",
    "ins": "National Health Identifier",
    "lastname": "Used lastname",
    "male": "Male",
    "moreInfo": "Show all information",
    "notGiven": "Not given",
    "nurse": "Nurse",
    "oid": "OID number",
    "phone": "Phone number",
    "profession": "Profession",
    "profile": "Profile",
    "ssn": "Social Security Number",
    "title": "Profile",
    "usedFirstname": "Used firstname",
    "usedLastname": "Used lastname"
  },
  "search": {
    "searchPatient": "Search a patient"
  },
  "support": {
    "contactUs": "Contact support",
    "byEmail": "by email at ",
    "or": "or",
    "byPhone": "by phone at"
  },
  "report": {
    "title": "Event",
    "category": "Category",
    "message": "Message"
  },
  "thresholdSettings": {
    "thresholds": "Thresholds",
    "thresholdUpdated": "Threshold updated",
    "severeHyperglycemia": "Severe hyperglycemia",
    "hyperglycemia": "Hyperglycemia",
    "severeHypoglycemia": "Severe hypoglycemia",
    "hypoglycemia": "Hypoglycemia",
    "normal": "Target glycemia",
    "units": "mg/dL",
    "gestationalThresholds": "Glycemia thresholds",
    "beforeBreakfast": "Before breakfast",
    "beforeMeal": "Before meal",
    "afterMeal": "After meal",
    "alertThresholds": "Notification thresholds"
  },
  "pumpEvents": {
    "title": "Pump events",
    "category": "Event",
    "insulin": "Insulin",
    "primeSize": "Prime size",
    "tempRate": "Temp. rate",
    "tempRatePercent": "Temporary basal rate",
    "isTemp": "Yes",
    "isNotTemp": "No"
  },
  "inclusionAgent": {
    "title": "Inclusion proposals",
    "accept": "Suggest monitoring",
    "startTelemonitoring": "Start telemonitoring",
    "reject": "Decline",
    "cancel": "Cancel",
    "requiredPhone": "We need a phone number to propose monitoring to the patient",
    "inclusionRequestSent": "Monitoring request sent",
    "contactPatientTitle": "Patient contact",
    "contactPatient": "We will contact the patient and notify you of their choice",
    "rejected": "Monitoring request rejected",
    "disappear": "The patient will disappear from the list",
    "phonePlaceholder": "Phone number",
    "includePatient": "Add patient",
    "patientAccepted": "Monitoring accepted by patient",
    "viewOnLibreView": "View on LibreView",
    "stats": {
      "TBR": "TBR",
      "TIR": "TIR",
      "CV": "CV",
      "GMI": "GMI",
      "hypo_count": "Nb. Hypo"
    },
    "source": {
      "robot": "Agent",
      "tooltip": "Inclusion suggestion by Stēto Agent"
    },
    "noMoreSuggestions": "No inclusion proposals for the moment.",
    "lastStep": "Last step"
  },
  "models": {
    "activityIntensity": {
      "low": "Low",
      "medium": "Average",
      "high": "High",
      "unknown": "Unspecified"
    },
    "pumpModel": {
      "unknown": "Unknown",
      "minimed": "MiniMed",
      "minimed640g": "MiniMed 640G",
      "minimed740g": "MiniMed 740G",
      "minimed780g": "MiniMed 780G",
      "omnipodDash": "Omnipod Dash",
      "omnipod5": "Omnipod 5",
      "tandemSlimX2": "t:slim X2",
      "tandemSlimX2ControlIQ": "t:slim X2 Control IQ"
    },
    "diabetesType": {
      "type1": "Type 1",
      "type2": "Type 2",
      "gestational": "Gestational",
      "gestationalNoInsulin": "GD no insulin",
      "gestationalWithInsulin": "GD with insulin",
      "unknown": "Unknown"
    },
    "insulinType": {
      "slow": "Slow insulin",
      "fast": "Fast insulin",
      "slow_short": "Slow ins.",
      "fast_short": "Fast ins."
    },
    "insulinReason": {
      "bolus": "Bolus insulin",
      "basal": "Basal insulin",
      "bolus_short": "Bolus",
      "basal_short": "Basal"
    },
    "nurseInclusionPatientStatus": {
      "suggestedToDoc": "Suggested",
      "doctorRefused": "Refused",
      "patientIncluded": "Included",
      "nurseCancelled": "Cancelled",
      "unknown": "Unknown"
    },
    "medicationSchema": {
      "noInsulin": "No insulin",
      "insulinPen": "Insulin pen",
      "insulinPump": "Insulin pump"
    },
    "reinclusionSuggestion": {
      "pendingTag": "Reinclusion suggested"
    },
    "telemonitoringTag": {
      "active": "Active",
      "active_long": "Active telemonitoring",
      "expiringSoon": "Expires soon",
      "expiringSoon_long": "Telemonitoring expires soon",
      "expired": "Expired",
      "expired_long": "Expired telemonitoring",
      "expiredRecently": "Expired recently",
      "expiredRecently_long": "Telemonitoring expired recently",
      "onboarding": "Onboarding ongoing",
      "onboarding_long": "Patient onboarding is ongoing",
      "gestationalNoInsulin": "GD no insulin",
      "gestationalNoInsulin_long": "Gestational diabetes without insulin",
      "nurseAskedForReinclusion": "Reinclusion suggested",
      "nurseAskedForReinclusion_long": "Reinclusion suggested by nurse"
    },
    "meal": {
      "breakfast": "Breakfast",
      "lunch": "Lunch",
      "dinner": "Dinner",
      "snack": "Snack",
      "unknown": "Unspecified meal"
    },
    "mealSize": {
      "light": "Light",
      "medium": "Medium",
      "heavy": "Heavy",
      "unknown": "Unspecified"
    },
    "reportCategory": {
      "severeHypoglycemia": "Severe hypoglycemia",
      "perceivedHypoglycemia": "Perceived hypoglycemia",
      "perceivedHyperglycemia": "Perceived hyperglycemia",
      "techAlert": "Technical issues",
      "other": "Other"
    },
    "pumpEventCategory": {
      "cannulaFilled": "Cannula changed",
      "tubingFilled": "Tubing changed",
      "cartridgeFilled": "Cartridge changed",
      "profileChanged": "Pump profile changed",
      "podChanged": "Pod changed",
      "podActivated": "Pod activated",
      "podDeactivated": "Pod deactivated",
      "basalRateChanged": "Basal rate changed",
      "dailyBasal": "Daily basal"
    },
    "practitionerBillingStatus": {
      "toProcess": "To process",
      "processed": "Processed",
      "error": "Error"
    },
    "practitionerBillingType": {
      "retrocessionSteto": "Stēto retrocession",
      "retrocessionDoctor": "Doctor retrocession",
      "cotation": "Summaries for quotation"
    },
    "pumpMode": {
      "noControl": "Manual mode",
      "pining": "Manual mode",
      "openLoop": "Manual mode",
      "closedLoop": "Closed loop mode",
      "limited": "Limited closed loop mode",
      "manual": "Manual mode"
    },
    "userMode": {
      "sleeping": "Sleep mode",
      "exercising": "Sport mode",
      "normal": "Normal mode"
    },
    "contactType": {
      "nurse": "Nurse",
      "family": "Family",
      "helper": "Helper",
      "unknown": "Other"
    },
    "contactRelationship": {
      "grandParent": "Grandparent",
      "parent": "Parent",
      "parentInLaw": "Parent-in-law",
      "partner": "Spouse",
      "child": "Child",
      "sibling": "Sibling",
      "cousin": "Cousin",
      "friend": "Friend",
      "unknown": "Other"
    },
    "refuseReinclusionReason": {
      "noClinicalNeed": "No clinical need",
      "nonCompliant": "Patient not consenting",
      "other": "Other",
      "unknown": "Unknown"
    }
  },
  "QaTools": {
    "glycemiaDataManagement": "Glycemia data management",
    "downloadCSVTitle": "Download glycemia data",
    "downloadCSV": "Download CSV",
    "uploadCSV": "Upload CSV",
    "uploadCSVTitle": "Upload glycemia data",
    "generateDataTitle": "Generate glycemia data",
    "generateData": "Generate",
    "deleteDataTitle": "Delete glycemia data",
    "deleteData": "Delete",
    "onboarding": "Onboarding management",
    "skipOnboarding": "Skip onboarding"
  },
  "fileManager": {
    "noFile": "None"
  },
  "reinclusion": {
    "doctorTitle": "Your nurse suggests re-including this patient. They have not been telemonitored for {{days}} days.",
    "doctorTitleWithNurseName": "{{nurseName}} suggests re-including this patient. They have not been telemonitored for {{days}} days.",
    "doctorCTAAccept": "Re-include",
    "doctorCTADeny": "Decline",
    "actionButton": "Suggest reinclusion",
    "activeTag": "Reinclusion suggested",
    "agent": {
      "banner": {
        "acceptCTA": "Suggest reinclusion",
        "refuseCTA": "Dismiss",
        "tir": "TIR",
        "tbr": "TBR",
        "notTelemonitoredSince": "This patient is not telemonitored since {{days}} days",
        "title": "Stēto has identified that this patient could benefit from renewed telemonitoring support.\nWould you like to suggest to the doctor to re-include this patient?",
        "titlePatientMessage": "This patient, whose follow-up has expired, has sent a message.\nWould you like to suggest their re-inclusion so their care can continue?",
        "autoArchiveTag": "Expires on {{date}}",
        "autoArchiveTooltip": "If you take no action, this suggestion will be archived automatically on {{date}}\nso that we can offer you new suggestions."
      },
      "proposeSuccessToast": "Suggestion sent",
      "refuseModal": {
        "cancel": "Cancel",
        "otherPlaceholder": "Please specify the reason",
        "submit": "Submit",
        "subtitle": "Why do you think reinclusion is not relevant for this patient?",
        "title": "Help us refine our suggestions!"
      },
      "refuseSuccessToast": "Thank you for your feedback"
    },
    "cancelAction": "Cancel suggestion",
    "proposeModalCancel": "Cancel",
    "proposeModalPlaceholder": "Reason for the suggestion",
    "proposeModalSubmit": "Submit suggestion",
    "proposeModalTitle": "Message to the doctor"
  },
  "patientSync": {
    "title": "Synchronization",
    "indexTitle": "My platforms",
    "ongoingImportTitle": "Patients being imported",
    "accessDenied": "The feature to add patients through LibreView interoperability is currently unavailable.",
    "accessDeniedDescription": "For now, pairing your LibreView clinic is done exclusively with the help of your Stēto contact.\nIf you would like to pair your LibreView account to import your patients into Stēto, please reach out to your contact.",
    "index": {
      "intro": "Synchronize your manufacturer platforms to identify patients eligible for telemonitoring",
      "sectionTitle": "Platforms"
    },
    "libreview": {
      "title": "Abbott LibreView",
      "subtitle": "Abbott · FreeStyle Libre 2, 2+, select and 3",
      "connected": "Connected",
      "description": "Import your LibreView clinic patients into Stēto.",
      "importPatients": "Import patients",
      "connectClinic": "Connect my clinic",
      "connectionTitle": "Abbott LibreView",
      "connectionBody": "For now, pairing your LibreView clinic is done exclusively with the help of your Stēto contact. If you would like to pair your LibreView account to import your patients into Stēto, please reach out to your contact.\n\nOnce pairing is successful, refresh this page",
      "refresh": "Refresh page",
      "close": "Close"
    },
    "lgc": {
      "title": "Practice Management Software",
      "connectionTitle": "Practice Management Software",
      "connectionBody": "For now, setting up access to your practice management software is done directly with your Stēto contact",
      "subtitle": "Doctolib, Weda, Maiia, AxiSanté, ...",
      "importPatients": "Import patients",
      "connectSoftware": "Connect my software",
      "close": "Close"
    },
    "groupedInclusion": {
      "selectPatients": "Confirm selection ({{count}})",
      "proposeTelemonitoring": "Propose TLS ({{count}} patients)",
      "proposeTelemonitoringSuccess": "TLS proposal successful for {{count}} patients"
    },
    "libreviewTable": {
      "name": "Patient",
      "tir": "TIR",
      "tbr": "TBR",
      "age": "Age",
      "lastDataSince": "Last data",
      "ignore": "No longer followed",
      "patientIgnored": "Patient marked “No longer followed”",
      "lessThanADay": "Less than a day",
      "filters": {
        "tir": "TIR (%) less than",
        "tbr": "TBR (%) greater than",
        "lastData": "Last data",
        "and": "AND",
        "or": "OR",
        "lastDataOptions": {
          "lt1m": "Less than 1 month",
          "lt3m": "Less than 3 months",
          "all": "All patients"
        },
        "reset": "Reset filters",
        "summary": "{{total}} patients on Libreview · {{matching}} matching applied filters · {{selected}} selected"
      }
    },
    "ongoingImport": {
      "title": "Complete the phone numbers",
      "subtitle": "Of your {{count}} imported patients, {{withPhone}} have a phone number and can be proposed for telemonitoring. {{missingPhone}} numbers still need to be entered.",
      "sidebar": {
        "selfTitle": "Complete the numbers yourself",
        "selfBody": "Enter the numbers on the left as you go, then click “Propose TLS”. Stēto will contact the patients to offer them telemonitoring follow-up",
        "completeLaterButton": "Complete later",
        "delegateTitle": "Delegate to secretariat",
        "delegateBody": "Download the list of patients to complete and forward it to your secretariat.",
        "delegateButton": "Download the list",
        "delegateSuccess": "List downloaded",
        "lgcTitle": "Temporary software access",
        "lgcBody": "Authorize a Stēto agent to retrieve the numbers from your practice management software",
        "lgcButton": "Configure access"
      }
    },
    "ongoingInclusionTable": {
      "name": "Patient",
      "phone": "Phone number",
      "phoneSaved": "Phone number saved",
      "deleted": "Patient removed from the list"
    }
  },
  "inputs": {
    "browse": "Browse..."
  },
  "table": {
    "sorting": {
      "sortable": "Sort column",
      "ascending": "Sorted ascending",
      "descending": "Sorted descending"
    }
  }
}
